var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ejs-grid',{ref:"modRecordsGrid",attrs:{"dataSource":_vm.modRecords,"columns":_vm.modColumns,"gridLines":"Vertical"},on:{"rowSelected":_vm.modRecordsChanged,"rowDeselected":_vm.modRecordsChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }